import styled from 'styled-components';

import { Button } from 'components/Button';

const Wrapper = styled.div`
  position: relative;
`;

const SendButton = styled(Button)`
  position: absolute;

  top: 0;
  right: 0;
`;

export { Wrapper, SendButton };
